import config from '@scripts/modules/config';

/**
* Поиск товаров, запрос данных
*/

class LiveSearchRequest {

  /**
   * Define JSON
   * @typedef {string} JSON
   */  

  /**
   * Функция, вызываемая при успешном получении данных с сервера.
   *
   * @callback onSuccessCallback
   * @param {JSON} data - JSON.
   */

  /**
   * Функция, вызываемая при возникновении ошибок
   *
   * @callback onErrorCallback
   * @param {string} message - Error message.
   */

  /**
   * 
   * @param {onSuccessCallback} onSuccess Функция, вызываемая при успешном получении данных с сервера
   * @param {onErrorCallback} onError Функция, вызываемая при возникновении ошибок
   */
  constructor(onSuccess, onError) {
    // this.url = 'http://alsagor-front/build/api/live-search.php';
    this.url = config.apiUrl + '?task=search';
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.init();
   }

  init() {
    const request = new XMLHttpRequest();
    this.request = request;

    request.onreadystatechange = () => { 
      if (request.readyState !== 4) return;

      if (request.status !== 200) {
        this.onError(request.statusText);
        return;
      }

      const responseType = request.getResponseHeader("Content-Type");
      
      if (responseType.indexOf("application/json") === -1) {
        this.onError('Unknown response format (no JSON)');
        return;      
      }
        
      const response = JSON.parse(request.responseText); 
      
      if ("error" in response){
        this.onError(response['error']['message']);
        return;      
      }
      
      if ("data" in response){
        this.onSuccess(response['data']);
        return;
      }

      this.onError('Unknown response format (no data in JSON)');
    };
  }

  // отправляет запрос на получение данных с сервера
  search(what) {
    this.request.open("POST", this.url);
    // в теле запроса - свойства объекта, как если бы они были парами имя/значение HTML-формы
    this.request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    this.request.send("what=" + encodeURIComponent(what.replace("%20", "+"))); 
  }

  //  отменяет запрос, выполняющийся в текущий момент
  cancel() {
    this.request.abort();
  }
}

export default LiveSearchRequest;